<template>
  <div id="mountNode" :style="{width:width}">
    <div class="editor" >
<!--      <Header  @addName="clickAddName" />-->
<!--      <div style="height: 54px;"></div>-->
      <div class="bottom-container">
        <Edit/>
      </div>
    </div>
  </div>
</template>

<script>
// import Header from '../../../components/Header'
import Edit from '../../../components/Edit'

export default {
  name: 'Editor',
  components: {
    // Header,
    Edit
  },
  created() {
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.editor {
  position: relative;
  width: 100%;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.bottom-container {
  position: relative;
  padding: 10px 25px;
  background-color: #fff;
}
</style>
